import { fetchGetService, fetchPostService } from '@/modules/api'

const state = {
  loaded: true,
  main: {
    title: '',
    description: '',
    email: '',
    colorGuid: ''
  }
}

const getters = {
  getMain: state => state.main,
  getTitle: state => state.main.title,
  getColorGuid: state => state.main.colorGuid,
  getDescription: state => state.main.description,
  getEmail: state => state.main.email,
  getLoaded: state => state.loaded
}

const mutations = {
  UPDATE_MAIN_TITLE: (state, string) => {
    state.main.title = string
  },
  UPDATE_MAIN_DESCRIPTION: (state, string) => {
    state.main.description = string
  },
  UPDATE_MAIN_EMAIL: (state, string) => {
    state.main.email = string
  },
  UPDATE_MAIN_COLORGUID: (state, string) => {
    state.main.colorGuid = string
  },
  UPDATE_LOADED: (state, boolean) => {
    state.loaded = boolean
  }
}

const actions = {
  async fetchGetPage ({ dispatch }, payload) {
    dispatch('updateLoaded', false)
    const service = payload.service
    const params = payload.params || {}
    const { data } = await fetchGetService(service, params)

    await dispatch('updateFiltersDate')

    // FIlters
    await dispatch('updateFiltersCategories', data)
    // Users
    await dispatch('updateUsers', data)
    // Guests
    await dispatch('updateGuests', data)
    // Spotlight
    await dispatch('updateSpotlight', data)
    // Documents
    await dispatch('updateDocuments', data)
    // Events
    await dispatch('updateEvents', data)
    // Groups
    await dispatch('updateGroups', data)
    // Board
    await dispatch('updateBoard', data)
    // Pages
    await dispatch('updatePages', data)
    // Holidays
    await dispatch('updateHolidays', data)
    // Travels
    await dispatch('updateTravels', data)
    // Remote Working
    await dispatch('updateRemoteWorking', data)
    // Profile
    await dispatch('updateProfile', data)
    // Paragraphs
    await dispatch('updateParagraphs', data)

    if (data.main) dispatch('updateMain', data.main)

    dispatch('updateLoaded', true)
  },

  updateLoaded: ({ commit }, status) => {
    commit('UPDATE_LOADED', status)
  },

  updateFiltersDate: ({ dispatch }) => {
    dispatch('filters/updateStartDate', '', { root: true })
    dispatch('filters/updateEndDate', '', { root: true })
  },

  updateFiltersCategories: ({ dispatch }, { filters }) => {
    const categories = filters && filters.categories ? [ ...filters.categories ] : []
    dispatch('filters/updateCategories', categories, { root: true })
  },

  updateSpotlight: ({ dispatch }, { spotlight }) => {
    const title = spotlight && spotlight.title ? spotlight.title : ''
    const items = spotlight && spotlight.items ? [ ...spotlight.items ] : []
    dispatch('spotlight/updateTitle', title, { root: true })
    dispatch('spotlight/updateItems', items, { root: true })
  },

  updateDocuments: ({ dispatch }, { documents }) => {
    const title = documents && documents.title ? documents.title : ''
    const items = documents && documents.items ? [ ...documents.items ] : []
    const total = documents && documents.total ? documents.total : 0
    dispatch('documents/updateTitle', title, { root: true })
    dispatch('documents/updateItems', items, { root: true })
    dispatch('documents/updateTotal', total, { root: true })
  },

  updateEvents: ({ dispatch }, { events }) => {
    if (events) {
      const title = events && events.title ? events.title : ''
      const items = events && events.items ? [ ...events.items ] : []
      const pastTitle = (events && events.past && events.past.title) ? events.past.title : ''
      const pastTotal = (events && events.past && events.past.total) ? events.past.total : 0
      const pastItems = (events && events.past && events.past.items) ? [...events.past.items] : []
      const upcomingTitle = (events && events.upcoming && events.upcoming.title) ? events.upcoming.title : ''
      const upcomingTotal = (events && events.upcoming && events.upcoming.total) ? events.upcoming.total : 0
      const upcomingItems = (events && events.upcoming && events.upcoming.items) ? [...events.upcoming.items] : []
      const calendarTitle = (events && events.calendar && events.calendar.title) ? events.calendar.title : ''
      const calendarItems = (events && events.calendar && events.calendar.items) ? [...events.calendar.items] : []
      const detailItems = (events && events.detail && events.detail.items) ? [...events.detail.items] : []

      dispatch('events/updateTitle', title, { root: true })
      dispatch('events/updateItems', items, { root: true })
      dispatch('events/updatePastTitle', pastTitle, { root: true })
      dispatch('events/updatePastTotal', pastTotal, { root: true })
      dispatch('events/updatePastItems', pastItems, { root: true })
      dispatch('events/updateUpcomingTitle', upcomingTitle, { root: true })
      dispatch('events/updateUpcomingTotal', upcomingTotal, { root: true })
      dispatch('events/updateUpcomingItems', upcomingItems, { root: true })
      dispatch('events/updateCalendarTitle', calendarTitle, { root: true })
      dispatch('events/updateCalendarItems', calendarItems, { root: true })
      dispatch('events/updateDetailItems', detailItems, { root: true })
    }
  },

  updateUsers: ({ dispatch }, { users }) => {
    const title = users && users.title ? users.title : ''
    const items = users && users.items.length ? [ ...users.items ] : []
    const total = users && users.total ? users.total : 0

    dispatch('users/updateTitle', title, { root: true })
    dispatch('users/updateItems', items, { root: true })
    dispatch('users/updateTotal', total, { root: true })
  },

  updateGuests: ({ dispatch }, { guests }) => {
    const items = guests && guests.items.length ? [ ...guests.items ] : []
    dispatch('guests/updateItems', items, { root: true })
  },

  updateGroups: ({ dispatch }, { groups }) => {
    const title = groups && groups.title ? groups.title : ''
    const total = groups && groups.total ? groups.total : 0
    const items = groups && groups.items ? [ ...groups.items ] : []
    dispatch('groups/updateTitle', title, { root: true })
    dispatch('groups/updateTotal', total, { root: true })
    dispatch('groups/updateItems', items, { root: true })
  },

  updatePages: ({ dispatch }, { pages }) => {
    const title = pages && pages.title ? pages.title : ''
    const total = pages && pages.total ? pages.total : 0
    const items = pages && pages.items ? [ ...pages.items ] : []
    dispatch('pages/updateTitle', title, { root: true })
    dispatch('pages/updateTotal', total, { root: true })
    dispatch('pages/updateItems', items, { root: true })
  },

  updateBoard: ({ dispatch }, { board }) => {
    const items = board && board.items ? [ ...board.items ] : []
    dispatch('board/updateItems', items, { root: true })
  },

  updateHolidays: ({ dispatch }, { holidays }) => {
    const user = holidays && holidays.user ? holidays.user : { firstname: '', lastname: '', avatar: '' }
    const entitlement = holidays && holidays.entitlement ? holidays.entitlement : []
    const overview = holidays && holidays.overview ? holidays.overview : { total: 0, items: [] }
    dispatch('holidays/updateEntitlement', entitlement, { root: true })
    dispatch('holidays/updateOverview', overview, { root: true })
    dispatch('holidays/updateUser', user, { root: true })
  },

  updateTravels: ({ dispatch }, { travels }) => {
    const request = travels && travels.request ? travels.request : {}
    const overview = travels && travels.overview ? travels.overview : { total: 0, items: [] }
    const user = travels && travels.user ? travels.user : { firstname: '', lastname: '', avatar: '' }
    dispatch('travels/updateRequest', request, { root: true })
    dispatch('travels/updateOverview', overview, { root: true })
    dispatch('travels/updateUser', user, { root: true })
  },

  updateRemoteWorking: ({ dispatch }, { remoteWorking }) => {
    const overview = remoteWorking && remoteWorking.overview ? remoteWorking.overview : { total: 0, items: [] }
    const user = remoteWorking && remoteWorking.user ? remoteWorking.user : { firstname: '', lastname: '', avatar: '' }
    dispatch('remoteWorking/updateOverview', overview, { root: true })
    dispatch('remoteWorking/updateUser', user, { root: true })
  },

  updateProfile: ({ commit }, { profile }) => {
    if (profile && profile.personal) {
      commit('profile/updatePersonal', profile.personal, { root: true })
    }
    if (profile && profile.subscriptions) {
      commit('profile/updateSubscriptions', profile.subscriptions, { root: true })
    }
  },

  updateParagraphs: ({ dispatch }, { paragraphs }) => {
    const items = paragraphs && paragraphs.items.length ? [ ...paragraphs.items ] : []
    dispatch('paragraphs/updateItems', items, { root: true })
  },

  /*
  *
  *
  *
  *
  *
  */
  // ASYNC FETCH FILTERS
  async fetchGetSearch ({ rootGetters, dispatch }, activeFilters) {
    // Documents
    dispatch('fetchGetDocuments', activeFilters)
    // Events
    dispatch('fetchGetEvents', activeFilters)
    // Contacts
    dispatch('fetchGetUsers', activeFilters)
    // Groups
    dispatch('fetchGetGroups', activeFilters)
    // Pages
    dispatch('fetchGetPages', activeFilters)
  },
  async fetchGetGroups ({ rootGetters, dispatch }, activeFilters) {
    dispatch('updateLoaded', false)
    const { data } = await fetchPostService('filters-groups', { activeFilters })
    dispatch('updateGroups', data)
    dispatch('updateLoaded', true)
  },
  async fetchGetPages ({ rootGetters, dispatch }, activeFilters) {
    dispatch('updateLoaded', false)
    const { data } = await fetchPostService('filters-pages', { activeFilters })
    dispatch('updatePages', data)
    dispatch('updateLoaded', true)
  },
  async fetchGetUsers ({ rootGetters, dispatch }, activeFilters) {
    dispatch('updateLoaded', false)
    const { data } = await fetchPostService('filters-users', { activeFilters })
    dispatch('updateUsers', data)
    dispatch('updateLoaded', true)
  },
  async fetchGetDocuments ({ rootGetters, dispatch }, activeFilters) {
    dispatch('updateLoaded', false)
    const { data } = await fetchPostService('filters-documents', { activeFilters })
    dispatch('updateDocuments', data)
    dispatch('updateLoaded', true)
  },
  async fetchGetEvents ({ dispatch, rootGetters }, activeFilters) {
    // Add active filters
    // const { data } = await fetchPostService('filters-events')
    dispatch('updateLoaded', false)
    const { data } = await fetchPostService('filters-events', { activeFilters })
    dispatch('updateEvents', data)
    dispatch('updateLoaded', true)
  },
  async fetchGetCalendarEvents ({ dispatch, rootGetters }, activeFilters) {
    dispatch('updateLoaded', false)
    const { data } = await fetchPostService('filters-calendar', { activeFilters })
    dispatch('updateEvents', data)
    dispatch('updateLoaded', true)
  },

  /*
  * ASYNC LOADMORE
  */

  async fetchGetAddUsers ({ rootGetters, dispatch }) {
    dispatch('updateLoaded', false)
    const { data } = await fetchPostService('filters-users', {
      activeFilters: rootGetters['filters/getActiveFilters'],
      offset: rootGetters['users/getOffset']
    })
    dispatch('users/addItems', data.users, { root: true })
    dispatch('updateLoaded', true)
  },

  async fetchGetAddDocuments ({ rootGetters, dispatch }) {
    dispatch('updateLoaded', false)
    const { data } = await fetchPostService('filters-documents', {
      activeFilters: rootGetters['filters/getActiveFilters'],
      offset: rootGetters['documents/getOffset']
    })
    dispatch('documents/addItems', data.documents, { root: true })
    dispatch('updateLoaded', true)
  },

  async fetchGetAddPastEvents ({ dispatch, rootGetters }) {
    dispatch('updateLoaded', false)
    const { data } = await fetchPostService('filters-past-events', {
      activeFilters: rootGetters['filters/getActiveFilters'],
      offset: rootGetters['events/getPastOffset']
    })
    dispatch('events/addPastItems', data.events.past, { root: true })
    dispatch('updateLoaded', true)
  },

  async fetchGetAddUpcomingEvents ({ dispatch, rootGetters }) {
    dispatch('updateLoaded', false)
    const { data } = await fetchPostService('filters-upcoming-events', {
      activeFilters: rootGetters['filters/getActiveFilters'],
      offset: rootGetters['events/getUpcomingOffset']
    })
    dispatch('events/addUpcomingItems', data.events.upcoming, { root: true })
    dispatch('updateLoaded', true)
  },

  async fetchGetAddPages ({ rootGetters, dispatch }) {
    dispatch('updateLoaded', false)
    const { data } = await fetchPostService('filters-pages', {
      activeFilters: rootGetters['filters/getActiveFilters'],
      offset: rootGetters['pages/getOffset']
    })
    dispatch('pages/addItems', data.pages, { root: true })
    dispatch('updateLoaded', true)
  },

  async fetchGetAddHolidaysOverview ({ dispatch, rootGetters }) {
    dispatch('updateLoaded', false)
    const { data } = await fetchPostService('holidays-overview', {
      offset: rootGetters['holidays/getOverviewOffset']
    })
    dispatch('holidays/addOverview', data.holidays.overview, { root: true })
    dispatch('updateLoaded', true)
  },

  async fetchGetAddTravelsOverview ({ dispatch, rootGetters }) {
    dispatch('updateLoaded', false)
    const { data } = await fetchPostService('travels-overview', {
      offset: rootGetters['travels/getOverviewOffset']
    })
    dispatch('travels/addOverview', data.travels.overview, { root: true })
    dispatch('updateLoaded', true)
  },

  async fetchGetAddRemoteWorkingOverview ({ dispatch, rootGetters }) {
    dispatch('updateLoaded', false)
    const { data } = await fetchPostService('remote-working-overview', {
      offset: rootGetters['remoteWorking/getOverviewOffset']
    })
    dispatch('remoteWorking/addOverview', data.remoteWorking.overview, { root: true })
    dispatch('updateLoaded', true)
  },

  // Main
  updateMain: ({ commit, dispatch }, main) => {
    commit('UPDATE_MAIN_TITLE', main.title ? main.title : '')
    commit('UPDATE_MAIN_DESCRIPTION', main.description ? main.description : '')
    commit('UPDATE_MAIN_EMAIL', main.email ? main.email : '')
    commit('UPDATE_MAIN_COLORGUID', main.colorGuid ? main.colorGuid : '')
  },

  updateTitle: ({ commit, dispatch }, title) => {
    commit('UPDATE_MAIN_TITLE', title)
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
